import { ACTIVESEARCHING } from "../../actions/portal/";

export default function(state = false, action){
  switch (action.type) {
    case ACTIVESEARCHING:
    return action.payload;
    default:
  }

  return state;
}
